import { Button, Modal, toast } from '@ethsign/ui';
import { useEffect, useState } from 'react';

import { SingPassIcon, UAEIcon } from '@/components';
import { useUserInfo } from '@/hooks';

import { setPrimaryEkyc } from '@/services';

import { CheckItem } from './CheckItem';

export const EKycSetPrimaryModal = () => {
  const [open, setOpen] = useState(false);
  const { user, fetchUser } = useUserInfo();
  const [primary, setPrimary] = useState<any>();
  useEffect(() => {
    if (user.eKyc) {
      setPrimary(user.eKyc);
    }
  }, [user]);

  const { uaepassUserId, uaepassUserName, singpassUserId, singpassUserName } = user || {};
  const [loading, setLoading] = useState(false);
  const onClose = () => {
    setOpen(false);
  };

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await setPrimaryEkyc(primary);
      await fetchUser();
      setOpen(false);
      setLoading(false);
      toast({
        variant: 'success',
        title: 'Success',
        description: 'Primary eKYC identity set successfully'
      });
    } catch (error) {
      setLoading(false);
      return;
    }
  };

  return (
    <>
      <Modal
        open={open}
        onOpenChange={setOpen}
        header={
          <>
            <div className="text-lg font-medium text-gray-900">Set your primary eKYC identity</div>
            <div className="text-sm text-gray-500 mt-[8px]">
              Please select one of the following verified identity as your primary signature identity.
            </div>
          </>
        }
        trigger={
          <Button className=" shrink-0 ml-4" variant="outline">
            Set Primary
          </Button>
        }
        onCancel={onClose}
        onConfirm={handleConfirm}
        confirmButtonProps={{
          loading,
          variant: 'primary'
        }}
      >
        <div>
          {singpassUserName && singpassUserId && (
            <CheckItem
              icon={<SingPassIcon />}
              name={`SingPass: ${singpassUserName} `}
              id={`*****${singpassUserId.slice(-4)}`}
              checked={primary === 'singpass'}
              onClick={() => {
                setPrimary('singpass');
              }}
            ></CheckItem>
          )}
          {uaepassUserName && uaepassUserId && (
            <CheckItem
              icon={<UAEIcon />}
              name={`UAE PASS: ${uaepassUserName} `}
              id={`*****${uaepassUserId.slice(-4)}`}
              checked={primary === 'uaepass'}
              onClick={() => {
                setPrimary('uaepass');
              }}
            ></CheckItem>
          )}
        </div>
      </Modal>
    </>
  );
};
